var render, staticRenderFns
import script from "./AssignmentSearchPrototype.vue?vue&type=script&lang=js&"
export * from "./AssignmentSearchPrototype.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentSearchPrototype.vue?vue&type=style&index=0&id=2c000e34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports